const strings = {
    LANG_MENU_ARIA_LABEL: {
        en: 'Select language',
        sv: 'Välj språk',
    },
    MODAL_CLOSE_ARIA_LABEL: {
        en: 'Close modal',
        sv: 'Stäng modal',
    },
    HEADER_BACK_BUTTON_ARIA_LABEL: {
        en: 'Navigate to previous page',
        sv: 'Navigera till föregående sida',
    },
    READMORE_BUTTON_LABEL: {
        en: 'Read more',
        sv: 'Läs mer',
    },
    FOOTER_MENU_HOME_LABEL: {
        en: 'Home',
        sv: 'Hem',
    },
    FOOTER_MENU_GUIDES_LABEL: {
        en: 'Guides',
        sv: 'Guider',
    },
    OPENING_HOURS: {
        en: {LABEL: 'Open today', CLOSED: 'Closed'},
        sv: {LABEL: 'Öppet idag', CLOSED: 'Stängt'},
    },
    STARTPAGE_TITLE: {
        en: 'Your day at',
        sv: 'Din dag på',
    },
    AUDIOGUIDE_BUTTON_LABEL: {
        en: 'Listen to Audio Guide',
        sv: 'Lyssna på audioguiden',
    },
    AUDIOGUIDE_ERROR_TEXT: {
        en: 'Failed to load the audio guide',
        sv: 'Misslyckades med att ladda audioguiden',
    },
    AUDIOGUIDE_ERROR_CLOSE_BUTTON: {
        en: 'Close',
        sv: 'Stäng',
    },
    AUDIOGUIDE_LANGUAGE_ARIA_LABEL: {
        en: 'Choose language',
        sv: 'Välj språk',
    },
    GUIDES_PAGE_TITLE: {
        en: 'Exhibition Guides',
        sv: 'Utställningsguider',
    },
}

export default strings;